export const inquiryDataConstants = {
    GET_SUCCESS: 'GET_INQUIRY_DATA_SUCCESS',
};
